<template>
  <el-dialog
    title="导入通用查询条件"
    width="560px"
    v-drag
    class="kye-dialog__modal-in-tab"
    :modal-append-to-body="false"
    :close-on-press-escape="escape"
    :close-on-click-modal="false"
    :visible.sync="show"
    custom-class="kye-custom-filter-import">
    <div
      class="edit-div"
      contenteditable="true"
      v-html="rulesJson"
      @blur="handleRulesJsonInput">
    </div>
    <template slot="footer">
      <kye-button
        type="primary"
        :disabled="!rulesJson"
        @click="importRules">确定
      </kye-button>
      <kye-button
        @click="show = false">取消
      </kye-button>
    </template>
  </el-dialog>
</template>

<script>
  export default {
    name: 'template-import-dialog',
    props: {
      escape: Boolean
    },
    data () {
      return {
        show: false,
        rulesJson: ''
      }
    },
    methods: {
      importRules () {
        try {
          let rules = JSON.parse(this.rulesJson)
          if (rules && Array.isArray(rules)) {
            this.$emit('change', rules)
            this.$message.success('导入通用查询条件成功')
            this.show = false
          } else {
            throw new Error()
          }
        } catch (e) {
          this.$message.warning('通用查询条件解析失败')
        }
      },
      handleRulesJsonInput (e) {
        this.rulesJson = e.target.innerHTML
      }
    }
  }
</script>

<style lang="scss">
  .kye-custom-filter-import {
    .edit-div {
      height: 300px;
      border: 1px solid #ccc;
      padding: 8px;
      overflow-y: auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/public/components/query-table/template-import-dialog.vue